<template>
  <div :class="isPc ? pcClass : mobileClass" :style="rootStyle">
    <div class="company-policy-popup-content-container" :style="{ borderTopColor: customColor }">
      <div class="content">
        <div class="container-body">
          <div class="body-content">
            <div v-if="!hasCustomer" class="title">
              <template v-for="headerContent in header">
                {{ headerContent.i18nContent }}
              </template>
            </div>
            <div v-else-if="hasCustomer && policyInfo.link" class="title">
              <span>{{ policyInfo.companyName }}</span>
            </div>
            <div class="checkbox-group">
              <el-scrollbar class="checkbox-scroll" :style="scrollStyle">
                <el-form class="policy-form" ref="form" :model="formModel" :rules="formRules">
                  <el-form-item class="policy-item" v-for="(policy, key) in bodyContent" :key="key" :prop="`policy_${policy.id}`">
                    <span v-if="policy.type==='CONTENT'" v-html="policy.i18nContent" class="policy-type-content"></span>
                    <el-checkbox v-if="policy.type==='CHECKBOX'" v-model="formModel[`policy_${policy.id}`]" class="checkbox" :key="policy.id">
                      <span v-html="policy.i18nContent"></span>
                    </el-checkbox>
                  </el-form-item>
                </el-form >
              </el-scrollbar>
            </div>
          </div>
        </div>
        <div v-if="showSystemPolicy" class="system-policy">
          <div class="policy-item">
            <el-checkbox v-model="agreeSystemPolicy" class="checkbox" @change="handleSystemPolicyChange">
              {{ $t('common.label.agreePolicy') }}
              <a class="policy-link" href="/tos/" target="_blank">{{ $t('login.company.register.candidate.policy.link1') }}</a>
              &
              <a class="policy-link" href="/policy/" target="_blank">{{ $t('login.company.register.candidate.policy.link2') }}</a>
            </el-checkbox>
          </div>
          <span v-if="showSystemPolicyWarning && !isConsent" class="system-policy-warning">{{ $t('common.message.agreeSystemPolicyWarning') }}</span>
        </div>
        <div class="container-footer">
          <div class="btn-group">
            <slot name="btnGroup">
              <template v-if="cancelBtn">
                <el-popconfirm
                  v-if="isApplicationAgreement || isTalentAgreement"
                  :confirm-button-text="$t('common.btn.confirm')"
                  :cancel-button-text="$t('common.btn.cancel')"
                  :title="$t(isTalentAgreement ? 'common.message.revokeAllApplicationTip' : 'common.message.revokeCurrentPosition')"
                  @confirm="handleCancelBtnClick"
                >
                  <template #reference>
                    <el-button class="cancel-btn" :disabled="btnClicked">{{ cancelBtn }}</el-button>
                  </template>
                </el-popconfirm>
                <el-button v-else class="cancel-btn" :disabled="btnClicked" @click="handleCancelBtnClick">{{ cancelBtn }}</el-button>
              </template>
              <el-button v-if="submitBtn" class="confirm-btn footer-btn" :disabled="btnClicked" @click="handleAgreeBtnClick">{{ submitBtn }}</el-button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { deviceType } from '@/utils/common'
import { addI18nProperty } from '@/i18n'

export default {
  props: {
    policyInfo: {
      type: Object,
      required: true
    },
    showSystemPolicy: {
      type: Boolean,
      default: true
    },
    isApplicationAgreement: {
      type: Boolean,
      default: false
    },
    isAgreeSystemPolicy: {
      type: Boolean,
      default: false
    },
    isConsent: {
      type: Boolean,
      default: false
    },
    isTalentAgreement: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pcClass: 'resume-applicant-pc',
      mobileClass: 'resume-applicant-mobile',
      formModel: {
      },
      agreeSystemPolicy: false,
      showSystemPolicyWarning: false,
      scrollStyle: {
        height: null
      },
      btnClicked: false
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    hasCustomer () {
      return this.policyInfo.has_customer
    },
    hasColorCustomization () {
      return this.policyInfo.company_has_color_customization
    },
    customColor () {
      return this.policyInfo.company_custom_color ? this.policyInfo.company_custom_color : ''
    },
    rootStyle () {
      const style = {}
      if (this.customColor) {
        style['--custom-color'] = this.customColor
      }
      return style
    },
    // btnStyle () {
    //   const vm = this
    //   if (vm.hasColorCustomization && vm.customColor) {
    //     return {
    //       background: vm.customColor,
    //       border: `1px solid ${vm.customColor}`
    //     }
    //   }
    //   return {}
    // },
    header () {
      if (this.policyInfo.popup) {
        for (const header of this.policyInfo.popup.header) {
          addI18nProperty(header, 'i18nContent', 'content_cn', 'content_en')
        }
        // if (this.hasCustomer) {
        //   const result = this.policyInfo.popup.header
        //   result.shift()
        //   return result
        // }
        return this.policyInfo.popup.header
      }
      return null
    },
    defaultHeader () {
      if (this.policyInfo.popup && this.policyInfo.popup.customer_header) {
        return this.policyInfo.popup.customer_header
      } else if (this.policyInfo.link && this.policyInfo.customer_header) {
        const companyLogoImg = this.hasCustomer ? `<img src="${this.policyInfo.customer_header}" class="policy-logo" style="height: 70px">` : this.policyInfo.customer_header
        return companyLogoImg
      }
      if (this.hasCustomer && this.policyInfo.popup) {
        return this.header[0]?.i18nContent
      }
      return null
    },
    bodyContent () {
      if (this.policyInfo.popup) {
        _.forEach(this.policyInfo.popup.body, (policy) => {
          addI18nProperty(policy, 'i18nContent', 'content_cn', 'content_en')
        })
        return this.policyInfo.popup.body
      }
      _.forEach(this.policyInfo.link, (link) => {
        addI18nProperty(link, 'i18nContent', 'content_cn', 'content_en')
      })
      return this.policyInfo.link
    },
    cancelBtn () {
      if (this.policyInfo.popup) {
        const footerBtn = _.find(this.policyInfo.popup.footer, footerBtn => footerBtn.type === 'BUTTON_CANCEL')
        if (footerBtn) {
          addI18nProperty(footerBtn, 'i18nCancelBtn', 'content_cn', 'content_en')
          return footerBtn.i18nCancelBtn
        }
      }
      return this.$t('common.btn.cancel')
    },
    submitBtn () {
      if (this.policyInfo.popup) {
        const footerBtn = _.find(this.policyInfo.popup.footer, footerBtn => footerBtn.type === 'BUTTON_SAVE')
        if (footerBtn) {
          addI18nProperty(footerBtn, 'i18nCancelBtn', 'content_cn', 'content_en')
          return footerBtn.i18nCancelBtn
        }
      }
      return this.$t('common.btn.save')
    },
    formRules () {
      if (this.isConsent) {
        return null
      }

      const validateCheckBox = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('common.message.continueWithAgreePolicy')))
        } else {
          callback()
        }
      }
      const rules = {}
      const checkboxRequired = [
        {
          validator: validateCheckBox,
          trigger: 'change'
        }
      ]
      _.forEach(this.bodyContent, (policy) => {
        if (policy.is_required) {
          rules['policy_' + policy.id] = checkboxRequired
        }
      })
      return rules
    }
  },
  mounted () {
    this.resetFormHeight()
    if (this.isConsent) {
      this.formatAgreementStatus()
    }
  },
  methods: {
    formatAgreementStatus () {
      // 初始化协议同意状态
      this.agreeSystemPolicy = this.isAgreeSystemPolicy
      _.forEach(this.bodyContent, (policy) => {
        this.$set(this.formModel, `policy_${policy.id}`, policy.is_agree)
      })
    },
    handleSystemPolicyChange () {
      if (!this.agreeSystemPolicy) {
        this.showSystemPolicyWarning = true
      } else {
        this.showSystemPolicyWarning = false
      }
    },
    async handleAgreeBtnClick () {
      let validCompanyPolicy = false
      let validSystemPolicy = !this.showSystemPolicy
      this.$refs.form.validate((valid) => {
        validCompanyPolicy = valid
      })
      if (this.showSystemPolicy) {
        if (!this.agreeSystemPolicy) {
          this.showSystemPolicyWarning = true
          validSystemPolicy = false
        } else {
          this.showSystemPolicyWarning = false
          validSystemPolicy = true
        }
      }
      if (validCompanyPolicy && validSystemPolicy) {
        const policyItemIds = []
        for (const policy in this.formModel) {
          if (policy.startsWith('policy_')) {
            policyItemIds.push(policy.substring(7))
          }
        }
        this.$emit('submit', true, policyItemIds)
      }
    },
    async handleCancelBtnClick () {
      this.$emit('submit', false)
    },
    async resetFormHeight () {
      let form = this.$refs.form
      if (!form) {
        await this.$nextTick()
        form = this.$refs.form
      }
      let el
      if (form instanceof Element) {
        el = form
      } else {
        el = form.$el
      }
      this.scrollStyle.height = `${el.offsetHeight + 15}px`
    }
  },
  watch: {
    bodyContent () {
      this.resetFormHeight()
    }
  }
}
</script>

<style lang="scss" scoped>
.resume-applicant-pc {
  max-height: 70vh;
  // width: 100%;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 20%;

  .company-policy-popup-content-container {
    width: 40%;
    // height: 450px;
    // border: 1px solid;
    // border-top: 14px solid;
    background: #fff;
    position: relative;
    &::before {
      content: "";
      width: 10px;
      height: 100%;
      background: #666666;
      position: absolute;
      top: 0;
    }

    .content {
      margin: 34px 40px 15px 40px;

      .container-header {
        margin-top: 7px;
        margin-bottom: 25px;

        .policy-logo-content {
          height: 60px;
        }

        .policy-logo-content-no-customer {
          height: 60px;
        }
      }

      .container-body {
        // margin-bottom: 20px;
        min-height: 280px;

        .body-content {
          .title {
            font-weight: 700;
            font-size: 14px;
            text-align: center;
            line-height: normal;
            color: #606266;
          }

          .checkbox-group {
            .checkbox-scroll {
              height: 235px;
              width: 100%;

              .policy-form {
                .policy-item {
                  // margin-bottom: 10px;
                  .policy-type-content {
                    display: block;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  }

                  &:last-child {
                    margin-bottom: 10px;
                  }
                }
              }

              ::v-deep {
                .el-scrollbar__wrap {
                  overflow-x: hidden;
                }

                .is-horizontal {
                  display: none;
                }
              }

              ::v-deep {
                p {
                  margin: 0;
                }

                a {
                  color: #0096cc;
                }
              }
            }

            ::v-deep {
              .el-form-item {
                margin-bottom: auto;
              }
            }

            ::v-deep .el-form-item__content {
              display: flex;
              flex-direction: column;
              line-height: unset;

              .el-form-item__error {
                left: 22px;
                position:relative;
                color: #F56C6C;
              }

            }

            .checkbox {
              display: block;
              margin-top: 20px;
              ::v-deep .el-checkbox__label {
                white-space: pre-wrap;
                vertical-align: top;
                width: 90%;
              }

              ::v-deep .el-checkbox__input {
                vertical-align: top;
                margin-top: 1px;
              }

              span {
                color: black;

                &.error-message {
                  display: none;
                  color: red;
                }
              }
            }
          }
        }
      }

      .system-policy {
        margin-top: 10px;
        .policy-item {
          a {
            color: #0096cc;
          }

          ::v-deep {
            .el-checkbox {
              overflow: hidden;
              white-space: normal;
              display: flex;
              justify-content: flex-start;

              .el-checkbox__input {
                margin-top: 2px;
              }
            }
          }
        }
        .system-policy-warning {
          color: #F56C6C;
          font-size: 12px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          top: 100%;
          left: 0;
          left: 22px;
          position: relative;
        }
      }

      .container-footer {
        margin-top: 25px;

        .btn-group {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .footer-btn {
            font-size: 14px;
            border: 0;
            cursor: pointer;
            line-height: 14px;
            padding: 10px 30px;
            background: var(--custom-color);
            color: #fff;

            &:first-child {
              margin-left: 0;
              background: #a9a9a9;
              color: #fff;
              border: 1px solid #a9a9a9;
            }

            &:last-child {
              background: var(--custom-color);
              color: #fff;
              border: 1px solid var(--custom-color);
            }
          }
          .cancel-btn {
            font-size: 14px;
            border: 0;
            cursor: pointer;
            line-height: 14px;
            padding: 10px 30px;
            background: var(--custom-color);
            background: #a9a9a9;
            color: #fff;
            border: 1px solid #a9a9a9;
          }
        }
      }
    }
  }
}

.resume-applicant-mobile {
  max-height: 70vh;
  width: 100%;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 15%;

  .company-policy-popup-content-container {
    width: 70%;
    // border: 1px solid;
    border-top: 14px solid;
    background: #fff;
    padding: 20px;
    max-height: 70vh;
    overflow: auto;

    .content {
      overflow: hidden;
      height: 100%;
      .container-header {
        margin-top: 7px;
        margin-bottom: 25px;

        /* ::v-deep {
          .policy-logo {
            width: 100%;
          }
        } */

        .policy-logo-content {
          height: 60px;
        }
        .policy-logo-content-no-customer {
          height: 60px;
        }
      }

      .container-body {
        // margin-bottom: 20px;
        min-height: 30vh;

        .body-content {
          .title {
            font-weight: 700;
            font-size: 14px;
            text-align: center;
            line-height: normal;
            color: #606266;
          }

          .checkbox-group {
            .checkbox-scroll {
              width: 100%;

              .policy-form {
                // width: 90%;

                .policy-item {
                  // margin-bottom: 10px;
                  .policy-type-content {
                    display: block;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  }

                  &:last-child {
                    margin-bottom: 5px;
                  }
                }
              }

              ::v-deep {
                .el-scrollbar__wrap {
                  overflow-x: hidden;
                }

                .is-horizontal {
                  display: none;
                }
              }

              ::v-deep {
                p {
                  margin: 0;
                }

                a {
                  color: #0096cc;
                }
              }
            }

            ::v-deep {
              .el-form-item {
                margin-bottom: auto;
              }
            }

            ::v-deep .el-form-item__content {
              display: flex;
              flex-direction: column;
              line-height: unset;

              .el-form-item__error {
                left: 22px;
                position:relative;
                color: #F56C6C;
              }
            }

            .checkbox {
              display: block;
              margin-top: 20px;
              ::v-deep .el-checkbox__label {
                white-space: pre-wrap;
                vertical-align: top;
                width: 90%;
              }

              ::v-deep .el-checkbox__input {
                vertical-align: top;
                margin-top: 2px;
              }

              span {
                color: black;

                &.error-message {
                  display: none;
                  color: red;
                }
              }
            }
          }
        }
      }

      .system-policy {
        margin-top: 10px;
        width: 90%;
        .policy-item {
          a {
            color: #0096cc;
          }

          ::v-deep {
            .el-checkbox {
              overflow: hidden;
              white-space: normal;
              display: flex;
              justify-content: flex-start;
            }
            .el-checkbox__input {
              margin-top: 2px;
            }
          }
        }
        .system-policy-warning {
          color: #F56C6C;
          font-size: 12px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          top: 100%;
          left: 0;
          left: 22px;
          position: relative;
        }
      }

      .container-footer {
        margin-top: 30px;

        .btn-group {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .footer-btn {
            width: 120px;
            height: 30px;
            border-radius: 15px;
            margin: 0;
            padding: 0;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;

            &:first-child {
              margin-right: auto;
              margin-left: 0;
              background: #a9a9a9;
              color: #fff;
              border: 1px solid #a9a9a9;
            }

            &:last-child {
              margin-left: auto;
              background: #fff;
              color: var(--custom-color, #0096cc);
              border: 1px solid var(--custom-color, #0096cc);
            }
          }
          .cancel-btn {
            width: 120px;
            height: 30px;
            border-radius: 15px;
            margin: 0;
            padding: 0;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            background: #a9a9a9;
            color: #fff;
            border: 1px solid #a9a9a9;
          }
        }
      }
    }
  }
}
</style>
